export default __webpack_public_path__ + "static/media/0172_IMG5161.0281afb1.jpg";